import script from "./DebiteursView.vue?vue&type=script&setup=true&lang=js"
export * from "./DebiteursView.vue?vue&type=script&setup=true&lang=js"

import "./DebiteursView.vue?vue&type=style&index=0&id=d14c4ab6&lang=css"

const __exports__ = script;

export default __exports__